<template>
    <v-menu offset-y>
        <template #activator="{ on, attrs }">
            <v-btn
                text
                tile
                class="v-tab work-submenu-group"
                :class="{ 'v-tab--active work-submenu-group--active': active }"
                v-bind="attrs"
                v-on="on"
            >
                {{ item.title }}
                <v-icon small right>mdi-chevron-down</v-icon>
            </v-btn>
        </template>
        <v-list dense :aria-label="item.title">
            <v-list-item
                v-for="child in item.children"
                :key="child.route.name"
                :to="child.route"
                exact
                :aria-current="$route.name === child.route.name ? 'page' : null"
            >
                <v-list-item-title>{{ child.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'WorkSubmenuGroup',
    props: { item: { type: Object, required: true } },
    computed: {
        active() {
            return this.item.children.some(child => child.route.name === this.$route.name);
        },
    },
};
</script>

<style scoped>
.work-submenu-group { height: 100% !important; }
.work-submenu-group--active { box-shadow: inset 0 -2px 0 currentColor; }
</style>
